// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3MgVv","bigColWidth":"Table_bigColWidth__1c-16","biggerColWidth":"Table_biggerColWidth__5At2O","row":"Table_row__3FAop","col":"Table_col__3Z7lv"};